



















import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "../common/AsiDialogForm.vue";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import {AxiosError} from "axios";
import Order from "../../models/order/Order";
import OrderUpdate from "@/models/order/OrderUpdate";
import AsiTextField from "@/components/common/AsiTextField";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";

@Component({
	components: {AsiDatePicker, CompanyAutocompleteInput, AsiTextField, AsiDialogFormLayout}
})
export default class OrderUpdateDialogBasicData extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public order!: Order;

	private model: OrderUpdate | null = null;
	private maxFromDate: string | null = null;
	private minToDate: string | null = null;

	public created(): void {
		this.setOrderInternal();
		this.calculateDateBoundaries();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setOrderInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	private calculateDateBoundaries(): void {
		if (this.model === null) return;

		if (this.order.minDate !== null && this.model.dateTo !== null) {
			const dOrderMin = new Date(this.order.minDate);
			const dModelTo = new Date(this.model.dateTo);
			this.maxFromDate = dOrderMin.getTime() < dModelTo.getTime() ? this.order.minDate : this.model.dateTo;
		} else if (this.order.minDate === null) {
			this.maxFromDate = this.model.dateTo;
		} else {
			this.maxFromDate = this.order.minDate;
		}

		if (this.order.maxDate !== null && this.model.dateFrom !== null) {
			const dOrderMax = new Date(this.order.maxDate);
			const dModelFrom = new Date(this.model.dateFrom);
			this.minToDate = dOrderMax.getTime() > dModelFrom.getTime() ? this.order.maxDate : this.model.dateFrom;
		} else if (this.order.maxDate === null) {
			this.minToDate = this.model.dateFrom;
		} else {
			this.minToDate = this.order.maxDate;
		}
	}

	@Watch('order', {deep: true})
	private onOrderChanged(): void {
		this.setOrderInternal();
	}

	private setOrderInternal(): void {
		if (this.model === null) {
			this.model = new OrderUpdate(this.order);
		} else {
			this.model.setDetailModel(this.order);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$orderService.update(this.order.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
